/* global window */

export const isEmbeddedChartView = () => window.location.hash.indexOf('embed') !== -1
